// Model.js
// -----------------------
// @module Case
define("BTM.ItemSearcherCustomization.ItemSearcherCustomization.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/ItemSearcherCustomization/SuiteScript2/ItemSearcherCustomization.Service.ss"
            ),
            true
        )
});
});
